import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Users } from './users.model';
import { UsersService } from './users.service';


@Injectable()
export class UsersGuard implements Resolve<Users> {

  constructor(public router: Router, private usersService: UsersService) { }

  private userId: string;

  resolve(route: ActivatedRouteSnapshot) {
    this.userId = route.params['userId'];
    return this.usersService.getUsersById(this.userId);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/users/users.guard.ts